/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { spacing, Text } from "@packages/ui";
import type { PropsWithChildren } from "react";

const containerStyle: Interpolation = {
  display: "flex",
  flexDirection: "column",
  gap: spacing.s,
};

export const CrossReference = ({
  title,
  text,
  children,
}: PropsWithChildren<{ title: string; text: string }>) => {
  return (
    <div css={containerStyle}>
      <Text type="title">{title}</Text>
      <Text>{text}</Text>
      {children}
    </div>
  );
};
